import React from "react";
import { makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";


let useStyles = makeStyles((theme) => ({
    root:{
        width: 300,
        // width: '100%',
        position: 'relative',
        margin: '20px 0px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.down('700')]: {
            width: '100%',
        },
    },
    girdRight:{
        width: '30%',

    },
    
    girdLeft:{
        width: '69%',

    },
}))

export default function Index() {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            <div className={classes['girdRight']}>
            
                <Skeleton variant="rect" height={80} />
            </div>
              <div className={classes['girdLeft']}>
                <Skeleton variant="rect" height={40} width={'100%'} />
                <Skeleton variant="rect" height={40} width={'100%'} />
            </div>
        </div>
    )
}
